export default [
  {
    name: "HaloMart",
    image: require("../assets/img/clients/halomart.png"),
  },
  {
    name: "MNT Africa",
    image: require("../assets/img/clients/mntaftica.png"),
  },
  {
    name: "NovaPay",
    image: require("../assets/img/clients/novapay.png"),
  },
  {
    name: "Ownum Capital",
    image: require("../assets/img/clients/ownumcapital.png"),
  },
  {
    name: "Blue Sea Technologies",
    image: require("../assets/img/clients/bst.png"),
  },
  {
    name: "easyGym UK",
    image: require("../assets/img/clients/easygym.png"),
  },
  {
    name: "Fotis Gas",
    image: require("../assets/img/clients/fotisgas.png"),
  },
  {
    name: "Fix-IT",
    image: require("../assets/img/clients/fixit.png"),
  },
  {
    name: "Solar Tech Systems",
    image: require("../assets/img/clients/solartech.png"),
  },
  {
    name: "Techsolutely",
    image: require("../assets/img/clients/techsolutely.png"),
  },
  {
    name: "Wagona Maths",
    image: require("../assets/img/clients/wagonamaths.png"),
  },
  {
    name: "Hype Nation",
    image: require("../assets/img/clients/hypenation.png"),
  },
  {
    name: "Garsu Pasaulis",
    image: require("../assets/img/clients/garsupasaulis.png"),
  },
];
